/**
 * Fonctionnalites — grille 2x3 des features clés.
 */
import { colors, fonts } from "../../styles/tokens";
import useScrollFadeIn from "../../hooks/useScrollFadeIn";

const FEATURES = [
  {
    icon: "👥", titre: "Annuaire intelligent", plan: "Freemium",
    desc: "Fiches membres complètes, recherche instantanée, import depuis Excel, filtres avancés.",
  },
  {
    icon: "✓", titre: "Présences & Alertes", plan: "Freemium",
    desc: "Signalez les absents en 2 minutes. Alertes automatiques si un membre manque 3 cultes.",
  },
  {
    icon: "💰", titre: "Dons & Quêtes", plan: "Communauté+",
    desc: "Enregistrez les dons nominatifs et les quêtes de culte. Multi-devises : EUR, FCFA, CAD.",
  },
  {
    icon: "🤝", titre: "Bénévoles & Planning", plan: "Starter+",
    desc: "Planifiez vos équipes de service (son, louange, accueil) et recevez les confirmations.",
  },
  {
    icon: "🌐", titre: "Réseau multi-églises", plan: "Pro+",
    desc: "Gérez plusieurs antennes depuis un seul compte. Vue consolidée de tout votre réseau.",
  },
  {
    icon: "📊", titre: "Rapports & Exports", plan: "Pro+",
    desc: "PDF, Excel, CSV en un clic. Rapport financier pour votre assemblée générale.",
  },
];

export default function Fonctionnalites() {
  const [titleRef, titleStyle] = useScrollFadeIn();

  return (
    <section
      id="fonctionnalites"
      style={{
        padding: "clamp(64px, 10vw, 100px) clamp(16px, 4vw, 24px)",
        background: colors.surface,
        fontFamily: fonts.body,
        maxWidth: "100vw",
        overflowX: "hidden",
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div ref={titleRef} style={{ ...titleStyle, textAlign: "center", marginBottom: "56px" }}>
          <h2 style={{
            fontFamily: fonts.heading,
            fontSize: "clamp(32px, 4vw, 48px)",
            fontWeight: 700,
            color: colors.text,
            marginBottom: "12px",
            letterSpacing: "-0.01em",
          }}>
            Tout ce dont votre église a besoin.
          </h2>
          <p style={{ color: colors.textMuted, fontSize: "16px", maxWidth: 600, margin: "0 auto", lineHeight: 1.6 }}>
            Un outil complet, pensé pour les réalités africaines et diaspora.
          </p>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "20px",
        }}>
          {FEATURES.map((f, i) => (
            <FeatureCard key={f.titre} feature={f} delay={i * 80} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureCard({ feature, delay }) {
  const [ref, style] = useScrollFadeIn({ delay });
  return (
    <div
      ref={ref}
      style={{
        ...style,
        padding: "28px 24px",
        background: colors.card,
        border: `1px solid ${colors.border}`,
        borderRadius: "16px",
        transition: `${style.transition}, border-color 200ms, transform 200ms`,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.borderColor = colors.goldBorder; e.currentTarget.style.transform = "translateY(-3px)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.borderColor = colors.border; e.currentTarget.style.transform = "translateY(0)"; }}
    >
      <div style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        marginBottom: "12px",
      }}>
        <div style={{
          width: 48, height: 48, borderRadius: "12px",
          background: colors.goldDim,
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          fontSize: "24px",
        }}>
          {feature.icon}
        </div>
        <span style={{
          fontSize: "11px",
          fontWeight: 600,
          color: colors.gold,
          padding: "4px 10px",
          borderRadius: "999px",
          background: colors.goldDim,
          border: `1px solid ${colors.goldBorder}`,
          letterSpacing: "0.04em",
        }}>
          {feature.plan}
        </span>
      </div>
      <h3 style={{
        fontFamily: fonts.heading,
        fontSize: "22px",
        fontWeight: 600,
        color: colors.text,
        marginBottom: "8px",
      }}>
        {feature.titre}
      </h3>
      <p style={{ color: colors.textMuted, fontSize: "14px", lineHeight: 1.6 }}>
        {feature.desc}
      </p>
    </div>
  );
}
